import Catalyst from '@Services/Catalyst';

const trackButtonClick = (buttonType) => Catalyst.trackEvent('buttonClick', { buttonType: `${Catalyst.getPrefix()}:${buttonType}` });

// Draw conditions page
export const trackDrawInsertStructure = () => trackButtonClick('draw-conditions:insert-structure');
export const trackDrawClear = () => trackButtonClick('draw-conditions:clear');
export const trackDrawCancel = () => trackButtonClick('draw-conditions:cancel');
export const trackDrawSearchConditions = () => trackButtonClick('draw-conditions:search-conditions');
export const trackDrawLearnHowItWorks = () => trackButtonClick('draw-conditions:learn-how-it-works');
export const trackDrawLearnPanelExample = (exampleKey) => trackButtonClick(`draw-conditions:learn-how-it-works:example:${exampleKey}`);

// Condition Navigator list page
export const trackNavigatorDelete = () => trackButtonClick('reaction-conditions:delete');
export const trackNavigatorProjectNameEdit = () => trackButtonClick('reaction-conditions:project-name-edit');
export const trackNavigatorProjectSort = () => trackButtonClick('reaction-conditions:project-sort');
export const trackNavigatorDateSort = () => trackButtonClick('reaction-conditions:date-sort');
export const trackNavigatorProjectSource = () => trackButtonClick('reaction-conditions:project-source');
export const trackNavigatorEdit = () => trackButtonClick('reaction-conditions:edit');
export const trackNavigatorZoom = () => trackButtonClick('reaction-conditions:zoom');
export const trackNavigatorConditionsButton = () => trackButtonClick('reaction-conditions:conditions-button');
export const trackNavigatorDrawReactions = () => trackButtonClick('reaction-conditions:draw-reactions');

// Condition summary section (detail page)
export const trackSummaryTopReagents = (variant) => trackButtonClick(`condition-summary:top-reagents:${variant}`);
export const trackSummaryTopSolvents = (variant) => trackButtonClick(`condition-summary:top-solvents:${variant}`);
export const trackSummaryHide = () => trackButtonClick('condition-summary:hide-condition-summary');

// Retrosynthesis "Explore conditions" entry points (route-step popup and selection side panel)
export const trackRtExploreConditionsPopup = () => trackButtonClick('synthesis:explore-conditions-popup');
export const trackRtExploreConditionsSidePanel = () => trackButtonClick('synthesis:explore-conditions-side-panel');

// Reaction results "Explore conditions" entry point
export const trackResultsExploreConditions = () => trackButtonClick('reactions:explore-conditions');

// Similar condition sets section (detail page)
export const trackSimilarRank = () => trackButtonClick('similar-condition-sets:rank');
export const trackSimilarSortMedianYield = () => trackButtonClick('similar-condition-sets:sort-median-yield');
export const trackSimilarSortNumberOfReactions = () => trackButtonClick('similar-condition-sets:sort-number-of-reactions');
export const trackSimilarExamples = () => trackButtonClick('similar-condition-sets:examples');

// My projects (detail page)
export const trackMyProjectsExport1 = () => trackButtonClick('conditions-my-projects:export-1');
export const trackMyProjectsExport2 = () => trackButtonClick('conditions-my-projects:export-2');
export const trackMyProjectsReacted = () => trackButtonClick('conditions-my-projects:reacted');
export const trackMyProjectsUnreacted = () => trackButtonClick('conditions-my-projects:unreacted');
